import { format } from 'date-fns';
import _ from "lodash";
import { readString } from 'react-papaparse';
import { preview } from '../../components/timesheets/timesheet-import/timesheetImportHelpers';
import ParseDBF from "../../lib/ParseDBF";

import apiURL from './apiURL';
// const apiURL = "http://localhost:3000"
// 
console.log('apiURL2',apiURL)

const isNumber = (a) => (!isNaN(a))

// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];

// types of action
const Types = {
  TIMESHEETIMPORT_GET_MAPPING: "TIMESHEETIMPORT_GET_MAPPING",
  TIMESHEETIMPORT_IMPORTING_STATUS: "TIMESHEETIMPORT_IMPORTING_STATUS",
  TIMESHEETIMPORT_COMPLETE: "TIMESHEETIMPORT_COMPLETE",
  TIMESHEETIMPORT_FILENAME: "TIMESHEETIMPORT_FILENAME",
  TIMESHEETIMPORT_DATA_LOADED: "TIMESHEETIMPORT_DATA_LOADED",
  TIMESHEETIMPORT_PREPARE_FOR_PROCESSING: "TIMESHEETIMPORT_PREPARE_FOR_PROCESSING",
  TIMESHEETIMPORT_PREPARED_FOR_PROCESSING: "TIMESHEETIMPORT_PREPARED_FOR_PROCESSING",
  TIMESHEETIMPORT_SAVING_MAPPING: "TIMESHEETIMPORT_SAVING_MAPPING",
  TIMESHEETIMPORT_SHOW_MAPPING: "TIMESHEETIMPORT_SHOW_MAPPING",
  TIMESHEETIMPORT_IMPORT_DATES: "TIMESHEETIMPORT_IMPORT_DATES",
  TIMESHEETIMPORT_PROCESSING_WARNINGS: "TIMESHEETIMPORT_PROCESSING_WARNINGS",
  TIMESHEETIMPORT_WARNINGS: "TIMESHEETIMPORT_WARNINGS",
  TIMESHEETIMPORT_FILE_UPLOADED: "TIMESHEETIMPORT_FILE_UPLOADED",
  TIMESHEETIMPORT_FILE_UPLOADING: "TIMESHEETIMPORT_FILE_UPLOADING",
  TIMESHEETIMPORT_MODAL_OPEN: "TIMESHEETIMPORT_MODAL_OPEN",
  TIMESHEETIMPORT_SELECT_EMPLOYEE: "TIMESHEETIMPORT_SELECT_EMPLOYEE",
  TIMESHEETIMPORT_DOWNLOADING_TIMESHEET_TEMPLATE: "TIMESHEETIMPORT_DOWNLOADING_TIMESHEET_TEMPLATE",
  TIMESHEETIMPORT_DOWNLOADED_TIMESHEET_TEMPLATE: "TIMESHEETIMPORT_DOWNLOADED_TIMESHEET_TEMPLATE",
  TIMESHEETIMPORT_INVALID_DATE: "TIMESHEETIMPORT_INVALID_DATE",
  TIMESHEETIMPORT_DATA_CLEARED: "TIMESHEETIMPORT_DATA_CLEARED",
};

const getImportMapping = response => ({
  type: Types.TIMESHEETIMPORT_GET_MAPPING,
  payload: response
});

const timesheetImportGetMapping = () => {
  return (dispatch, getState) => {

    fetch(
      apiURL + `/settings/timesheet-mapping`,
      {
      // fetch('http://localhost:3000/report/templates' , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(data => {
      dispatch(getImportMapping(data))
    })
  }
}

/**
 * STATUS = True - Importing
 * STATUS = False - Not Importing
 * STATUS = Array - Error(s)
 */
const setImportingStatus = status => ({
  type: Types.TIMESHEETIMPORT_IMPORTING_STATUS,
  status
});

const timesheetImportComplete = () => ({
  type: Types.TIMESHEETIMPORT_COMPLETE,
});

const sendTimesheetData = () => {
  return async (dispatch, getState) => {

    const state = getState()

    if(state.timesheetImport.importStatus === true) return;

    const {dataToSend} = state.timesheetImport

    dispatch(setImportingStatus(true));

    // only return if person is linked in the system we do not want rogue data uploaded
    // const filteredDataNoSkip = dataToSend.filter(item => item.agreement);
    const filteredData = dataToSend.filter(item => item.agreement && !item.skip);
      
    // console.log('ImportTimesheetToSend',filteredData,filteredDataNoSkip)
    // window.ImportTimesheetToSend = filteredData;

    const chunkArray = (myArray, chunk_size) => {
      var results = [];
      
      while (myArray.length) {
          results.push(myArray.splice(0, chunk_size));
      }
      
      return results;
    }

    const chunkedData = chunkArray(filteredData,200)

    while (chunkedData.length) {

      const timesheetPostData = chunkedData.pop()

      await new Promise((resolve,reject) => {
         fetch(apiURL + '/settings/timesheets' , {
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify({timesheets:timesheetPostData}),
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(data => {
          resolve();
        })
      })
    }

    dispatch(timesheetImportComplete())

    //$.notify('Your timesheets have been imported', {type:'success'});
  }
}

const timesheetImportSetFilename = (filename) => ({
  type: Types.TIMESHEETIMPORT_FILENAME,
  filename
});

const timesheetDataLoaded = ({
  fields,
  data
}) => ({
  type: Types.TIMESHEETIMPORT_DATA_LOADED,
  fields,
  data
});


// not redux just a utility function
const toBuffer = (ab) => {
  var buf = Buffer.alloc(ab.byteLength);
  var view = new Uint8Array(ab);
  for (var i = 0; i < buf.length; ++i) {
      buf[i] = view[i];
  }
  return buf;
}

const timesheetImportInvalidDate = () => ({
  type: Types.TIMESHEETIMPORT_INVALID_DATE,
  invalidDate: true
})

const clearTimesheetImportData = () => ({
  type: Types.TIMESHEETIMPORT_DATA_CLEARED,
})

const handleTimesheetImportFiles = (files) => {
  return (dispatch, getState) => {
    // console.log('files',files)

    let reader = new FileReader();
    let file = files[0];
    console.log('file',file); //I can see the file's info

    dispatch(timesheetImportSetFilename(file.name))


    const fileParts = file.name.toLowerCase().split('.');
    const fileExtension = fileParts[fileParts.length - 1];


    reader.onload= () => {
        // console.log('readerResult',reader.result);
        let timesheetData = null;

        switch (fileExtension){
          case "csv": {
            const parsedCSV = readString(reader.result,{header:true,skipEmptyLines:true});

            dispatch(
              timesheetDataLoaded({
                fields: parsedCSV.meta.fields,
                data: parsedCSV.data
              })
            )
            // setFields(parsedCSV.meta.fields);
            // setData(timesheetData);
            // setDataToSend(false);

          }
          break;

          case "dbf":
          default: {
            // var array = new Uint8Array(reader.result); // read the actual file contents
            var buffer = toBuffer(reader.result); // read the actual file contents

            ParseDBF(buffer).then(data => {

              dispatch(
                timesheetDataLoaded({
                  fields: data.fields,
                  data: data.records
                })
              )

              // setFields(data.fields);
              // setData(data.records);
              // setDataToSend(false);

            })
          }
          break;
      }
    }

    if (fileExtension == 'csv'){
      reader.readAsText(file);
    } else {
      reader.readAsArrayBuffer(file)
    }

    // ParseDBF(files[0]);
  }
}

const setFileUploading = (file) => ({
  type: Types.TIMESHEETIMPORT_FILE_UPLOADING,
  file,
});

const setFileUploaded = (file, key) => ({
  type: Types.TIMESHEETIMPORT_FILE_UPLOADED,
  file,
  key,
});

const downloadingTimesheetTemplate = () => ({
  type: Types.TIMESHEETIMPORT_DOWNLOADING_TIMESHEET_TEMPLATE,
  downloading: true
});

const downloadedTimesheetTemplate = () => ({
  type: Types.TIMESHEETIMPORT_DOWNLOADED_TIMESHEET_TEMPLATE,
  downloading: false
});

const handleTimesheetPhotoImport = ({ file, company }) => {
  return (dispatch, getState) => {
    const state = getState();

    const path = '/settings/timesheets/images/upload';

    dispatch(setFileUploading(file.name));

    fetch(apiURL + path, {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({
        name: file.name,
        type: file.type,
        company
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('getImportStatus', data);

        const fileKey = data.key;

        // step 1 upload to AWS
        fetch(data.url, {
          credentials: 'include',
          method: 'PUT',
          body: file,
          headers: {
            Accept: 'application/json',
            'Content-Type': file.type,
          },
        }).then((data) => {
          dispatch(setFileUploaded(file.name, fileKey));
          // ask to process
          fetch((apiURL + "/settings/timesheets/images/analyse"), {
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify({ Key: fileKey }),
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            }
          });
        });
      });
  };
};

const setTimesheetTemplateModalOpen = (isModalOpen) => ({
  type: Types.TIMESHEETIMPORT_MODAL_OPEN,
  isModalOpen
});

const selectEmployee = (employee, selected) => ({
  type: Types.TIMESHEETIMPORT_SELECT_EMPLOYEE,
  employee,
  selected
});

const checkTimesheetTemplateStepFunctionStatus = (arn) => {
  return (dispatch, getState) => {
    fetch(apiURL + `/settings/describe-execution/${arn}`, {
      credentials: "include",
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(response => response.json())
    .then(data => {

      const finished = data.data.status != "RUNNING"

      if (finished) {
        if (data.data.status === 'SUCCEEDED') {

          const output = JSON.parse(data.data.output);

          let popup;
          popup = window.open(output.signedURL);
          if (!popup || popup.closed || typeof popup.closed == 'undefined') {
            alert('Popup Blocker is enabled! Please add this site to your exception list.');
          }
          dispatch(downloadedTimesheetTemplate())
          dispatch(setTimesheetTemplateModalOpen(false))
        } else {
          // fail
        }
      } else {
        setTimeout(() => dispatch(checkTimesheetTemplateStepFunctionStatus(arn)), 1000)
      }
    });
  }
};

const downloadTemplate = (body) => {
  return (dispatch, getState) => {
    dispatch(downloadingTimesheetTemplate())
    fetch(apiURL + `/settings/timesheet-template/download` , {
      credentials: 'include',
      method: 'POST',
      body: body,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    })
    .then(response => response.json())
    .then(data => {

      const arn = data.executionArn;

      setTimeout(() => dispatch(checkTimesheetTemplateStepFunctionStatus(arn)), 1000)
    })
  }
};

const timeDifference = (timeStart,timeEnd) => {
  let hourDiff = timeEnd.getHours() - timeStart.getHours();
  if (hourDiff < 0){
    timeEnd.setDate(timeEnd.getDate() + 1)
  }

  // console.log('hourDiff',hourDiff,timeEnd - timeStart,timeEnd.getTime() - timeStart.getTime())

  const difference = (timeEnd - timeStart) / 60 / 60 / 1000;

  return Math.round(difference * 100,0)/100
}



const setImportDates = ({from,to}) => ({
  type: Types.TIMESHEETIMPORT_IMPORT_DATES,
  from,
  to
});

const prepareForProcessing = () => ({
  type: Types.TIMESHEETIMPORT_PREPARE_FOR_PROCESSING
});

const timesheetsPrepared = (filteredTimesheets) => ({
  type: Types.TIMESHEETIMPORT_PREPARED_FOR_PROCESSING,
  filteredTimesheets
});

const prepareTimesheetImportForProcessing = () => {

  return (dispatch, getState) => {

    dispatch(prepareForProcessing())

    const state = getState();

    const {fields, data, fieldMapping, importFrom, importTo} = state.timesheetImport
    const {employeesByReference} = state.employees
  
    const newDataToSend = _.reject(data.map(record => {

      const item = {}

      Object.keys(fieldMapping).map(fieldName => {
        const res = preview(fieldName,fieldMapping,record)
        // added this to cover for multiple / renamings take only last valid field name
        if (res && typeof(res) !== 'undefined') {
          item[fieldMapping[fieldName]] = preview(fieldName,fieldMapping,record)
        }
      })

      const [
        theDate,
        fromDate,
        toDate
      ] = [
        item.date,
        importFrom,
        importTo
      ].map(date => format(date instanceof Date ? date : new Date(date), 'yyyy-MM-dd'))

      if (theDate < fromDate || theDate > toDate) {
        return false;
      }


      const employee = item.reference && employeesByReference?.[item.reference];
      if (employee){
        item.agreement = employee?.id;
        item.employee = employee?.employee;
      }

      const timeStart = new Date(`${item['date']} ${item['time-in']}`);
      const timeEnd = new Date(`${item['date']} ${item['time-out']}`);

      item.hours = timeDifference(timeStart,timeEnd);

      if (item.break && !isNaN(item.break)){
        item.hours = item.hours - (item.break ? item.break/60 : 0)
      }

      // PRMT Specific
      if (item.timeInStatus == "S"){
        item.hours = -item.hours
      }

      return item;

    }),(item) => (item == false ));

    const sortedData = _.orderBy(newDataToSend, ['reference', 'date', 'time-in'], ['asc', 'asc', 'asc'])

    dispatch(timesheetsPrepared(sortedData))
    // dispatch(processWarnings(filteredTimesheets))
    // (newDataToSend,leave);

    // setDataToSend(newDataToSend);
    // setProcessing(false);
  }
}


const processingWarnings = () => ({
  type: Types.TIMESHEETIMPORT_PROCESSING_WARNINGS,
});

const warningsGenerated = ({warnings,employeesNotFound,notFoundWarnings,ignore,timesheetsOutsideOfRange,warningsByReference}) => ({
  type: Types.TIMESHEETIMPORT_WARNINGS,
  warnings,
  notFoundWarnings,
  ignore,
  employeesNotFound,
  timesheetsOutsideOfRange,
  warningsByReference
});

const processWarnings = ({reference}) => {
  return (dispatch, getState) => {

    dispatch(processingWarnings())

    const state = getState()

    const {dataToSend,warningConditions,ignore} = state.timesheetImport
    const {employeesByReference} = state.employees
    const leave = state.leave.leave

    const newEmployeeNotFound = {}
    const newEmployeeTimesheetsOutsideOfRange = {}

    const newWarnings = reference ? _.reject(state.timesheetImport.warnings,{employeeByReference: reference}) : [];
    const notFoundWarnings = reference ? _.reject(state.timesheetImport.notFoundWarnings,{employeeByReference: reference}) : [];

    const warningsByReference = state.timesheetImport.warningsByReference ? state.timesheetImport.warningsByReference : {}

    console.log('startingWarnings subsetToProcess',newWarnings)

    const getValue = (variable,item) => {
      if (isNumber(variable) || Array.isArray(variable)){
        return variable;
      }

      const value = variable && variable.startsWith(":") ? item[variable.substring(1)] : variable
      // console.log('daValue',value,isNumber(value),`"${value}"`)
      return isNumber(value) ? value : `"${value}"`
    }

    // prevWarnings = state

    let dataToProcessWarnings = dataToSend;

    if (reference && typeof(reference) !== 'undefined'){
      delete warningsByReference[reference]
      dataToProcessWarnings = dataToProcessWarnings.filter(item => item.reference == reference);
      console.log('subsetToProcess',dataToProcessWarnings)
    }

    
    console.log('dataToProcessWarnings',dataToProcessWarnings)

    // const sortedData = _.orderBy(dataToProcessWarnings, ['reference', 'date', 'time-in'], ['asc', 'asc', 'asc'])

    // console.log('sortedData',sortedData)

    // sortedData.map((item,index) => {
    dataToProcessWarnings.map((item,index) => {

      // item.reference = String(item.reference)

      // if person is not in System and not ignored and agreement still valid

      console.log('item.reference',item.reference,item,item.reference)
      if (item.reference && !employeesByReference[item.reference]){
        newEmployeeNotFound[item.reference] = newEmployeeNotFound[item.reference] ? newEmployeeNotFound[item.reference] + 1 : 1;

        if (!ignore || !ignore[item.reference]){
          notFoundWarnings.push({
            index,
            key: `NF.${item.reference}.${item.date} ${item['time-in']}`,
            employeeByReference: item.reference,
            warningId: 'NF'
          })
        }
      } else {

        let itemHasWarning = false;

        console.log('item.reference2',item,item.reference)

        // check if timesheet entries are outside of range
        const employeeDetails = employeesByReference[item.reference];
        const timesheetDate = item.date;

        console.log('employeeDetails',employeeDetails)

        const applicableSalaries = employeeDetails?.salaries.find( salary => {

          const start = salary.start
          const end = salary.end
          // console.log('timesheetDateOutOfRangeTEST',timesheetDate,start,end)
          return  timesheetDate >= start && (
              !end ||
              timesheetDate <= end
            )
          }
        )

        if (!applicableSalaries){

          // console.log('timesheetDateOutOfRange',timesheetDate,employeeDetails.salaries)

          if (!newEmployeeTimesheetsOutsideOfRange[item.reference]){
            newEmployeeTimesheetsOutsideOfRange[item.reference] = []
          }
          newEmployeeTimesheetsOutsideOfRange[item.reference].push({
            index: index,
            key: `OutOfRange.${item.reference}.${item['date']} ${item['time-in']}`,
            employeeByReference: item.reference,
            warningId: 'OutOfRange'
          })
          item.skip = true;
        }
      
        warningConditions.map(warning => {

          const prevEntry = dataToProcessWarnings[index - 1];

          let prevHours = prevEntry && (prevEntry.totalHoursInDay || prevEntry.hours) || 0;
          let breakDuration = item.break && !isNaN(item.break) ? parseInt(item.break) : 0;
          let totalHoursInDay = parseFloat(item.hours);

          if (prevEntry && prevEntry.reference == item.reference ){

             const timeOutPrevDay = new Date(`${prevEntry['date']} ${prevEntry['time-out']}`);
             const timeInToday = new Date(`${item['date']} ${item['time-in']}`);

             const hourDifference = timeDifference(timeOutPrevDay,timeInToday);

            // if difference < 8 hours in between out/in treat as if same day
            if (hourDifference < 8 && hourDifference > 0){
              // console.log('hourDiff totalHoursInDay',hourDifference,item,prevEntry)
              // this is to be treated as same day.
              totalHoursInDay += parseFloat(prevEntry.hours)

              breakDuration += parseFloat(hourDifference)
            } 

            item.totalHoursInDay = totalHoursInDay;
            item.breakDuration = breakDuration;
            
          }

          if (warning.v1 && warning.v2){
            const v1 =  getValue(warning.v1,item);
            const v2 =  getValue(warning.v2,item);
            // console.log('v2',v2,`${v1} ${warning.operand} ${v2}`)
            
            let operation = `${v1} ${warning.operand} ${v2}`;

            if (warning.operand == "includes"){
              operation = `[${v2}].includes(${v1})`;
              // console.log('operation Includes',operation)
            }

            const result = v1 && v2 && eval(operation)

            // v1 && v2 && console.log(`${v1} ${warning.operand} ${v2}`,result)

            if (result){

              // console.log('warning.v1',warning.v1,item,prevEntry)
              if ([':totalHoursInDay',':breakDuration'].includes(warning.v1)){

                if (warning.id == 2){
                  console.log('hoursInDay',operation,warning,prevEntry,item)
                }

                // include previous line
                // console.log('warning.v1 push',warning.v1,item,prevEntry)
                newWarnings.push({
                  index: index - 1,
                  key: `${warning.id}.${item.reference}.${item['date']} ${item['time-in']}`,
                  employeeByReference: prevEntry.reference,
                  warningId: warning.id
                })

                if (!warningsByReference[prevEntry.reference]){
                  warningsByReference[prevEntry.reference] = {}
                }

                if (!warningsByReference[prevEntry.reference][index - 1]){
                  warningsByReference[prevEntry.reference][index - 1] = {
                    key: `${item.reference}.${item['date']} ${item['time-in']}`,
                    warnings: [warning.id]
                  }
                } else {
                  if (!warningsByReference[prevEntry.reference][index - 1].warnings.find(w => w == warning.id)){
                    warningsByReference[prevEntry.reference][index - 1].warnings.push(warning.id)
                  }
                }
                
              }

              newWarnings.push({
                index,
                key: `${warning.id}.${item.reference}.${item['date']} ${item['time-in']}`,
                employeeByReference: item.reference,
                warningId: warning.id
              })

              if (!warningsByReference[item.reference]){
                warningsByReference[item.reference] = {}
              }

              if (!warningsByReference[item.reference][index]){
                warningsByReference[item.reference][index] = {
                  key: `${item.reference}.${item['date']} ${item['time-in']}`,
                  warnings: [warning.id]
                }
              } else {
                if (! warningsByReference[item.reference][index].warnings.find(w => w == warning.id)){
                   warningsByReference[item.reference][index].warnings.push(warning.id)
                }
              }
              

              itemHasWarning = true;
                // console.log('warning.v1 push2',newWarnings)
            }
          }
        })

        // console.log('checkingforLeave',leave)

        const hasLeaveSameDay = leave && leave.find(leaveItem => 
            (
              format(new Date(leaveItem.date),"yyyy-MM-dd") <= item.date &&
              format(new Date(leaveItem.dateTo),"yyyy-MM-dd") >= item.date &&
              ["Approved"].includes(leaveItem.status) // only show warning if Approved 
            )
            && leaveItem.hours > 0
            && leaveItem.agreement == item.agreement
          );
        // console.log('hasLeave', leave && leave[0] && leave[0].start.substring(0,10),item, leave && leave.find(leaveItem => leaveItem.start.substring(0,10) == item.date));
        if (hasLeaveSameDay){
          // console.log('hasLeaveSameDay',hasLeaveSameDay,item.agreement,item.leave)
          if (!itemHasWarning){
            newWarnings.push({
              index: index,
              key: `${item.reference}.${item['date']} ${item['time-in']}`,
              employeeByReference: item.reference,
              warningId: 'Leave'
            })

            if (!warningsByReference[item.reference]){
              warningsByReference[item.reference] = {}
            }

            if (!warningsByReference[item.reference][index]){
              warningsByReference[item.reference][index] = {
                key: `${item.reference}.${item['date']} ${item['time-in']}`,
                warnings: ['Leave']
              }
            } else {
              warningsByReference[item.reference][index].warnings.push('Leave')
            }
            item.skip = true;
          } else {
            item.skip = true;
          }
          item.leave = hasLeaveSameDay;
        }

        const hasOverlappingHours = dataToProcessWarnings
            .filter(t => t.reference == item.reference)
            .find(timesheet =>
          (
            //Checking if the dates are the same then checking if they have any overlapping times
            //console.log("timesheet: ", {timesheet,item}) ||
            (item != timesheet) &&
            (item.date == timesheet.date) &&
            ((item['time-in'] >= timesheet['time-in']  &&
            item['time-in'] <= timesheet['time-out']) ||
            (item['time-out'] >= timesheet['time-in'] &&
            item['time-out'] <= timesheet['time-out']))
          ));

        if (hasOverlappingHours){
          newWarnings.push({
            index: index,
              key: `${item.reference}.${item['date']} ${item['time-in']}`,
              employeeByReference: item.reference,
              warningId: 'TimeOverlap'
          })
        }
      }

    })

    console.log('newWarnings',newWarnings)

    const sortedWarnings = _.orderBy(newWarnings, ['employeeByReference', 'warningId'], ['asc', 'asc']);
    const sortedNotFoundWarnings = _.orderBy(notFoundWarnings, ['employeeByReference', 'warningId'], ['asc', 'asc']);

    dispatch(warningsGenerated({
      warnings: sortedWarnings,
      notFoundWarnings: sortedNotFoundWarnings,
      employeesNotFound: newEmployeeNotFound,
      timesheetsOutsideOfRange: newEmployeeTimesheetsOutsideOfRange,
      warningsByReference
    }))

  }
}

const setSavingMappingStatus = (status) => ({
  type: Types.TIMESHEETIMPORT_SAVING_MAPPING,
  status
});

const setShowMapping = (show) => ({
  type: Types.TIMESHEETIMPORT_SHOW_MAPPING,
  show
});

const saveFieldMapping = (e) => {

  return (dispatch, getState) => {

    const state = getState()

    const {savingMapping, fields, fieldMapping} = state.timesheetImport

    if(savingMapping) return;

    dispatch(setSavingMappingStatus(true))

    fetch(apiURL + '/settings/timesheet-mapping' , {
      // fetch('http://localhost:3000/report/templates' , {
        credentials: 'include',
        // mode: 'cors',
        method: 'POST',
        body: JSON.stringify({
          fields,
          fieldMapping
        }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(data => {

      dispatch(setSavingMappingStatus(false))
    })
  }
}


const linkEmployee = (reference,id) => {
  return (dispatch, getState) => {

    //$.notify('Saving your change and updating your timesheet warnings.', {type:'success'});

    const state = getState()

    const {warnings,dataToSend} = state.timesheetImport
    const {employeesByReference} = state.employees
    const employee = employeesByReference[reference]

    const newData = dataToSend.map(item => {

      if (reference == item.reference){
        item.agreement = employee.id;
        item.employee = employee.employee;
      }

      return item
    })

    dispatch(timesheetsPrepared(newData));

    // setSaving(true);
    // console.log('linkEmployee',{reference})
    fetch(apiURL + '/settings/employee-reference' , {
      // fetch('http://localhost:3000/report/templates' , {
        credentials: 'include',
        // mode: 'cors',
        method: 'POST',
        body: JSON.stringify({
          reference,
          id
        }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(result => {
      
      // const newImportWarnings = _.reject(warnings,{employeeByReference:reference,warningId:"NF"})
      // const sortedWarnings = _.orderBy(newImportWarnings, ['employeeByReference', 'warningId'], ['asc', 'asc']);
      

      dispatch(
        processWarnings({
          reference
        })
      )

      // dispatch(timesheetsPrepared())

      // setData(newDataToSend);
      
      // console.log('processingWarningsData',_.filter(data,{reference:"467695M"}));
      // console.log('employeeByReference',employeeByReference["467695M"]);
      // console.log('processingWarningsLeave',leave);
      // processWarnings(newDataToSend,leave)

       //$.notify('Employee linked refreshing report', {type:'success'});
      console.log('link Employee saved',result)
    })
  }
}

const ignorePermanently = (reference) => {
  return (dispatch, getState) => {

    const state = getState()

    const notFoundWarnings = state.timesheetImport.notFoundWarnings
    const ignore = state.timesheetImport.ignore

    // setSaving(true);
    // console.log('ignoringReference',{reference})
    fetch(apiURL + '/settings/timesheet-ignore' , {
      // fetch('http://localhost:3000/report/templates' , {
        credentials: 'include',
        // mode: 'cors',
        method: 'POST',
        body: JSON.stringify({
          reference
        }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(data => {

      const ignoreData = ignore ? {...ignore} : {}
      ignoreData[reference] = true;

      // TODO find out why sending in notFound Warnings causes a huge memory leak
      // const newImportWarnings = _.reject(notFoundWarnings,{employeeByReference:reference})
      // const sortedWarnings = _.orderBy(newImportWarnings, ['employeeByReference', 'warningId'], ['asc', 'asc']);
      dispatch(warningsGenerated({
        // notFoundWarnings:sortedWarnings,
        ignore: ignoreData
      }))



      dispatch(
        processWarnings({
          // reference
        })
      )

      // obtained data
      // setSaving(false);
      // setShowSettings(false)
      // console.log('saved ignore reference',data)
    })
  }
}


const Actions = {
  timesheetImportGetMapping,
  sendTimesheetData,
  handleTimesheetImportFiles,
  handleTimesheetPhotoImport,
  prepareTimesheetImportForProcessing,
  timesheetsPrepared,
  getImportMapping,
  saveFieldMapping,
  setShowMapping,
  setImportDates,
  processWarnings,
  linkEmployee,
  ignorePermanently,
  setTimesheetTemplateModalOpen,
  selectEmployee,
  downloadTemplate,
  timesheetImportInvalidDate,
  clearTimesheetImportData,
}

// exports = {
//   Types,
//   Actions
// }

export { Actions, Types };

// exports.Types = Types
// exports.Actions = Actions